<script setup>
import VueDatePicker from '@vuepic/vue-datepicker';
import { sl } from 'date-fns/locale'
import { computed, ref } from 'vue'

const {value, header, placeholder, modelFormat, enableTimezone, format} = defineProps({
    value: {
        type: String,
        default: ''
    },
    header: {
        type: String,
        default: ''
    },
    placeholder: {
        type: String,
        default: 'Izberite datum in čas'
    },
    modelFormat: {
        type: String,
        default: 'yyyy-MM-dd HH:mm:ss'
    },
    enableTimezone: {
        type: Boolean,
        default: false
    },
    format: {
        type: String,
        default: 'dd.MM.yyyy HH:mm'
    },
    error: {
        type: [String, Array, Boolean],
        default: false
    },
    errorMessages: {
        type: [String, Array],
        default: () => []
    },
    label: {
        type: String,
        default: ''
    }
})

const emit = defineEmits(['update:modelValue'])

// Cast prop value to date
const date = ref(value ? new Date(value) : null)

// Update the date value and allow model binding to work outside of component
const updateValue = (date) => {
  if (date) {
    const localDate = new Date(date);
    const year = localDate.getFullYear();
    const month = String(localDate.getMonth() + 1).padStart(2, '0');
    const day = String(localDate.getDate()).padStart(2, '0');
    const hours = String(localDate.getHours()).padStart(2, '0');
    const minutes = String(localDate.getMinutes()).padStart(2, '0');
    emit('update:modelValue', `${year}-${month}-${day} ${hours}:${minutes}:00`);
  } else {
    emit('update:modelValue', null);
  }
}
</script>
<template>
    <div class="flex flex-col">
        <label class="text-sm font-medium text-gray-700" v-if="label">{{ label }}</label>
        <VueDatePicker 
            :class="{
                'border-red-500 border-[1px] mb-[0px]! mt-2 rounded-[0.25rem] text-red-500 placeholder:text-red-500': error,
                'mt-2 mb-6': !error
            }"
            v-model="date" 
            :locale="'sl'"
            :format-locale="sl"
            :format="format"
            :model-format="modelFormat"
            :placeholder="placeholder"
            auto-apply
            :enable-timezone="enableTimezone"
            @update:model-value="updateValue"
            :teleport="true"
        >
            <template #menu-header>
                <div class="flex justify-center">{{ header }}</div>
            </template>
        </VueDatePicker>
        <div class="v-input__details mt-[0px] mb-2" v-if="error">
            <div class="" role="alert" aria-live="polite" id="input-7-messages">
                <div class="v-messages__message text-red-500 ml-4">{{ error }}</div>
            </div>
        </div>
    </div>
</template>